import { Text } from '@app/components/core/typography/Text'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Icon } from '@app/components/core/icon/Icon'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import { AvatarStack } from '../avatarStack/AvatarStack'
import { Follower } from '@app/types/Follower'
import { Card } from './Card'
import { pages } from '@app/util/links'

export interface ConceptCardProps {
  image: string
  title: string
  description: string
  followers: Array<Follower>
  followerCount: number
  slug: string
}

export const ConceptCard = ({
  image,
  title,
  description,
  followers,
  followerCount,
  slug,
}: ConceptCardProps) => {
  const isMobile = useMediaQuery()
  const titleLineClamp = isMobile ? 2 : 3
  const descriptionLineClamp = isMobile ? 2 : 4

  return (
    <Card
      to={pages.serviceProviderConcept(slug)}
      image={image}
      orientation={isMobile ? 'vertical' : 'horizontal'}
      padded={false}
      imageStyle={{
        flexBasis: '50%',
      }}
      style={{
        maxHeight: '23rem',
      }}
    >
      {/* Title */}
      <Title.H3
        style={{ WebkitLineClamp: titleLineClamp, marginBottom: '0.5rem' }}
      >
        {title}
      </Title.H3>

      {/* Description */}
      <Text.Medium
        style={{
          color: 'var(--palette-blue-300)',
          display: '-webkit-box',
          WebkitLineClamp: descriptionLineClamp,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {description}
      </Text.Medium>

      {/* Follower Avatars */}
      <AvatarStack
        size={'extra-small'}
        avatars={followers || []}
        total={followerCount || 0}
        style={{ marginTop: '1rem' }}
      />

      <Card.Actions>
        <Icon
          icon={faArrowRight}
          size="small"
          style={{
            marginLeft: 'auto',
            color: 'var(--brand-secondary)',
            background: 'transparent',
            border: '2px solid var(--brand-secondary)',
            borderRadius: '50%',
            padding: '0.25rem',
          }}
        />
      </Card.Actions>
    </Card>
  )
}
